import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Information from './claimTabs/Information';
import СlaimIncidents from './claimTabs/СlaimIncidents';
import Documents from './shared/documents';
import History from './shared/history';

import CardLayout from '../../../components/CardLayout';
import { userPermissionsSelector } from '../../../ducks/profile';
import {createDefaultValueSelector, getCardConfigRequest} from "../../../ducks/gridCard";
import {CLAIMS_GRID} from "../../../constants/grids";

const ClaimCard = ({
    form,
    onChangeForm,
    name,
    id,
    load,
    isNotUniqueNumber,
    uniquenessNumberCheck,
    settings,
    error,
    title,
    onClose,
    actionsFooter,
    actionsHeader,
    loading,
    goToSoldTo,
}) => {
    const userPermissions = useSelector(state => userPermissionsSelector(state));

    const dispatch = useDispatch();
    const defaultValues = useSelector(createDefaultValueSelector);

    useEffect(()=>{
        !id && dispatch(getCardConfigRequest({name: CLAIMS_GRID, configFlag: false}));
    }, []);

    useEffect(() => {
        defaultValues &&
        Object.keys(defaultValues).forEach(key =>
            onChangeForm(null, {name: key, value: defaultValues[key]}),
        );
    }, [defaultValues]);

    const getPanes = () => {
        let obj = [
            {
                menuItem: 'information',
                render: () => (
                    <Information
                        form={form}
                        settings={settings}
                        error={error}
                        load={load}
                        isNotUniqueNumber={isNotUniqueNumber}
                        uniquenessNumberCheck={uniquenessNumberCheck}
                        onChange={onChangeForm}
                        goToSoldTo={goToSoldTo}
                    />
                ),
            }
        ];
        
        if (userPermissions.includes(177) && form.id) {
            obj.push({
                menuItem: 'documents',
                render: () => (
                    <Documents
                        gridName={name}
                        cardId={id}
                        isEditPermissions={userPermissions.includes(178)}
                        canAddDocuments={!form?.cannotAddDocuments}
                    />
                ),
            });
        }

        if (userPermissions.includes(171) && form.id) {
            obj.push({
                menuItem: 'incidents.IncomeIncidents',
                render: () => <СlaimIncidents form={form} />,
            });
        }

         if (userPermissions.includes(171) && form.id) {
            obj.push({
                menuItem: 'commentsHistory',
                render: () => <History cardId={id} type="comments" />,
            });
        }

        if (userPermissions.includes(185) && form.id) {
            obj.push({
                menuItem: 'history',
                render: () => <History cardId={id}  />,
            });
        }

        return obj;
    };

    return (
        <CardLayout
            title={title}
            actionsFooter={actionsFooter}
            actionsHeader={actionsHeader}
            content={getPanes}
            onClose={onClose}
            loading={loading}
        />
    );
};

export default ClaimCard;
